import { CityManagement } from "@/components/admin/CityManagement";

export default function CitiesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">City Management</h2>
        <p className="text-muted-foreground">Manage cities for flight destinations</p>
      </div>
      <CityManagement />
    </div>
  );
}
